import { createFileRoute } from '@tanstack/react-router';

import { ErrorBoundary } from '@/components/ErrorBoundary';
import { loaderUnitCampaignsPage } from '@/loaders/unit.campaigns.loader';
import { UnitCampaignsPage } from '@/routes/_authenticated/_account/fleets/$fleetId/units/$endCustomerUnitId/campaigns';

export const Route = createFileRoute('/_authenticated/_account/units/$endCustomerUnitId/campaigns/')({
  component: UnitCampaignsPage,
  errorComponent: ErrorBoundary,
  loader: loaderUnitCampaignsPage,
});
